import { get } from 'lodash';
import { Reducer } from 'redux';

import { FreeShapeAction, LoadingRequestState } from '../types';
import { splitOnLastUnderscore } from './requests';

const _PENDING = '_PENDING';
const _FULFILLED = '_FULFILLED';
const _REJECTED = '_REJECTED';

const initialState: LoadingRequestState = {};

/**
 * @deprecated since v.2.15.0
 *
 * Loading State Reducer which keep registration of the number of state-request.
 * @param {LoadingRequestState} state;
 * @param {StandardAction} action;
 * @returns {LoadingRequestState}
 */
export const loadingRequests: Reducer<LoadingRequestState, FreeShapeAction> = (
  state = initialState,
  action
) => {
  const [actionName, requestType] = splitOnLastUnderscore(action.type);
  let existingValue = 0;

  switch (requestType) {
    case _PENDING:
      return {
        ...state,
        [actionName]: get(state, actionName, 0) + 1
      };
    case _FULFILLED:
    case _REJECTED:
      existingValue = get(state, actionName, 0);
      if (existingValue === 0) {
        throw new Error(`Attempting to decrement request count on ${actionName} - something is very wrong.`);
      }
      return {
        ...state,
        [actionName]: get(state, actionName, 0) - 1
      };
    default:
      return state;
  }
};
